import { AxiosResponse } from 'axios';
import {
  SET_ADMIN_DASHBOARD_STATS,
  SET_DASHBOARD_STATS,
  SET_EMPLOYEE_DASHBOARD_STATS,
  SET_ERRORMSG,
} from '@/store/mutation_types';
import {
  GET_ADMIN_DASHBOARD_STATS,
  GET_DASHBOARD_STATS,
  GET_EMPLOYEE_DASHBOARD_STATS,
  CLEAR_STATS_ISLOADING,
} from '@/store/action_types';
import { StateObject } from '@/dtos/state.dto';
import Stats from '@/services/stats';
import { Module } from 'vuex';
import { GetAdminDashboardStats, GetDashboardStats, GetEmployeeDashboardStats } from '@/dtos/stats.dto';

const applyPayload = (target: StateObject, payload: { data?: any; isLoading: boolean }) => {
  if (payload.data !== undefined) target.data = payload.data;
  target.isLoading = payload.isLoading;
};

const stats: Module<any, {}> = {
  state: {
    dashboardStats: {
      data: null,
      isLoading: false,
    },
    employeeDashboardStats: {
      data: null,
      isLoading: false,
    },
    adminDashboardStats: {
      data: null,
      isLoading: false,
    },
  },
  getters: {
    dashboardStats: (state: { dashboardStats: any }) => state.dashboardStats,
    employeeDashboardStats: (state: { employeeDashboardStats: any }) => state.employeeDashboardStats,
    adminDashboardStats: (state: { adminDashboardStats: any }) => state.adminDashboardStats,
  },
  mutations: {
    [SET_DASHBOARD_STATS]: (
      state: { dashboardStats: StateObject },
      payload: { data: null; status: any; isLoading: any }
    ) => {
      payload.data != null ? (state.dashboardStats.data = payload.data) : null,
        (state.dashboardStats.isLoading = payload.isLoading);
    },
    [SET_EMPLOYEE_DASHBOARD_STATS]: (
      state: { employeeDashboardStats: StateObject },
      payload: { data?: any; isLoading: boolean }
    ) => {
      applyPayload(state.employeeDashboardStats, payload);
    },
    [SET_ADMIN_DASHBOARD_STATS]: (
      state: { adminDashboardStats: StateObject },
      payload: { data?: any; isLoading: boolean }
    ) => {
      applyPayload(state.adminDashboardStats, payload);
    },
  },
  actions: {
    [GET_DASHBOARD_STATS]: async ({ commit }: any, payload: any) => {
      commit(SET_DASHBOARD_STATS, { data: null, isLoading: true });

      const result: AxiosResponse = await Stats.getDashboardStats(
        payload as GetDashboardStats
      );

      if (result) {
        if (result.data.status) {
          commit(SET_DASHBOARD_STATS, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_DASHBOARD_STATS, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_DASHBOARD_STATS, { isLoading: false });
        return false;
      }
    },
    [GET_EMPLOYEE_DASHBOARD_STATS]: async ({ commit }: any, payload: GetEmployeeDashboardStats) => {
      // keep previous data visible while refreshing so the page never flashes empty
      commit(SET_EMPLOYEE_DASHBOARD_STATS, { isLoading: true });

      const result: AxiosResponse = await Stats.getEmployeeDashboardStats(payload);

      if (result) {
        if (result.data.status) {
          commit(SET_EMPLOYEE_DASHBOARD_STATS, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_EMPLOYEE_DASHBOARD_STATS, { isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      }
      commit(SET_EMPLOYEE_DASHBOARD_STATS, { isLoading: false });
      return false;
    },
    [GET_ADMIN_DASHBOARD_STATS]: async ({ commit }: any, payload: GetAdminDashboardStats) => {
      commit(SET_ADMIN_DASHBOARD_STATS, { isLoading: true });

      const result: AxiosResponse = await Stats.getAdminDashboardStats(payload);

      if (result) {
        if (result.data.status) {
          commit(SET_ADMIN_DASHBOARD_STATS, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_ADMIN_DASHBOARD_STATS, { isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      }
      commit(SET_ADMIN_DASHBOARD_STATS, { isLoading: false });
      return false;
    },
    [CLEAR_STATS_ISLOADING]: ({ commit }) => {
      commit(SET_DASHBOARD_STATS, { isLoading: false });
      commit(SET_EMPLOYEE_DASHBOARD_STATS, { isLoading: false });
      commit(SET_ADMIN_DASHBOARD_STATS, { isLoading: false });
    },
  },
};

export default stats;
